var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"tabs"},_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"tab",class:{ 'tab--active': _vm.activeTab === index },on:{"click":function($event){return _vm.changeTab(item.path)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }